export default __webpack_public_path__ + "static/media/logo.d34a237c.svg";